import { Link } from 'react-router-dom';
import Header from '../components/Header';

function Games() {
  return <>
    <Header />

    <div id="tiles">
        <Link id="games-pexeso" className='link' to="/games/pexeso">
            <span>Pexeso</span>
        </Link>
        <Link id="games-quiz" className='link' to="/games/quiz">
            <span>Kvízy</span>
        </Link>
    </div>
  </>
}

export default Games;